import { css } from 'linaria';

export const typesSection = css`
  width: 100%;
  margin-bottom: 80px;

  @media (--only-tablet) {
    margin-bottom: 24px;
  }

  @media (--only-mobile) {
    margin-bottom: 8px;
  }
`;

export const typesTitle = css`
  margin-bottom: 16px;

  @media (--to-desktop) {
    margin-bottom: 8px;
  }

  @media (--only-mobile) {
    font-size: 28px;
    line-height: 34px;
  }
`;

export const typesDescription = css`
  width: 730px;
  margin-bottom: 24px;

  @media (--only-desktop) {
    width: 697px;
  }

  @media (--to-desktop) {
    width: 100%;
  }

  @media (--only-mobile) {
    margin-bottom: 22px;
  }
`;

export const projectTypeContainer = css`
  display: flex;
  justify-content: space-between;

  @media (--only-tablet) {
    flex-direction: column;
  }

  @media (--only-mobile) {
    flex-direction: column;
    margin-right: -16px;
    margin-left: -16px;
  }
`;

export const projectType = css`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 580px;
  padding: 40px;
  background-color: var(--background-secondary);
  border-radius: var(--rounding-l);

  @media (--only-desktop) {
    width: 460px;
    padding: 32px;
  }

  @media (--to-desktop) {
    width: 100%;
    margin-bottom: 40px;
  }

  @media (--only-mobile) {
    padding: 24px 16px 32px;
    border-radius: unset;
  }
`;

export const projectTypeTitle = css`
  margin-bottom: 12px;

  @media (--only-mobile) {
    margin-bottom: 2px;
  }
`;

export const projectTypeSubtitle = css`
  margin-bottom: 12px;
  font-weight: 500;

  @media (--only-mobile) {
    margin-bottom: 8px;
  }
`;

export const projectTypeDescription = css`
  margin-bottom: 24px;

  @media (--only-mobile) {
    margin-bottom: 16px;
  }
`;

export const projectTypeCompositionTitle = css`
  margin-bottom: 8px;
  font-weight: 500;

  @media (--only-mobile) {
    margin-bottom: 2px;
  }
`;

export const projectTypeComposition = css`
  && {
    margin-bottom: 24px;

    li {
      margin-bottom: 0;
    }
  }
`;

export const projectTypeBottom = css`
  position: relative;
`;

export const projectTypePrice = css`
  margin-bottom: 12px;
`;

export const projectTypeSchedule = css`
  display: flex;
  margin-bottom: 40px;

  @media (--to-desktop) {
    margin-bottom: 32px;
  }
`;

export const projectTypeScheduleIcon = css`
  width: 20px;
  height: 20px;
  margin-right: 8px;

  @media (--only-mobile) {
    width: 16px;
    height: 16px;
  }
`;

export const projectTypeButtons = css`
  display: flex;
  justify-content: space-between;

  @media (--only-tablet) {
    justify-content: flex-start;
  }
`;

export const projectTypeExampleLink = css`
  && {
    @media (--only-desktop) {
      position: absolute;
      top: 0;
      right: 0;
      flex-direction: column;
      align-items: flex-start;
    }

    @media (--only-mobile) {
      position: absolute;
      top: 0;
      right: 0;
      flex-direction: column;
      align-items: flex-start;
      width: 57px;
      padding: 0;
    }
  }
`;

export const projectSignButton = css`
  @media (--only-mobile) {
    width: 100%;
  }
`;
